var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showJourneyFiltersEditor
        ? _c("modal", {
            attrs: { "show-on-mount": "" },
            on: {
              hidden: function($event) {
                return _vm.close()
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "modal-title",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "w-100" },
                        [
                          _c("h3", { staticClass: "d-inline-block mr-1" }, [
                            _vm._v(
                              _vm._s(
                                _vm.resource(
                                  "JourneyComposer_GenericFiltersModal_Title"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("help-popover", {
                            attrs: {
                              content: _vm.resource(
                                "JourneyComposer_FilterModal_GenericFiltersModal_Explanation"
                              )
                            }
                          })
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "modal-body",
                  fn: function() {
                    return [
                      _c("brick-filter-settings-editor", {
                        ref: "editor",
                        attrs: {
                          includedCategoryFilters: ["Audience", "NotAudience"],
                          conditions: _vm.editableFiltersModel,
                          "id-field": "id",
                          "can-write": _vm.canWrite,
                          "delete-group-confirmation-message": _vm.resource(
                            "JourneyComposer_GenericFiltersModal_DeleteGroupConfirmation"
                          ),
                          "delete-condition-confirmation-message": _vm.resource(
                            "JourneyComposer_GenericFiltersModal_DeleteConditionConfirmation"
                          )
                        },
                        on: {
                          "conditions-changed": function($event) {
                            _vm.editableFiltersModel = $event
                          },
                          "validation-state-changed": function($event) {
                            _vm.conditionsValid = $event
                          }
                        }
                      })
                    ]
                  },
                  proxy: true
                },
                {
                  key: "modal-footer",
                  fn: function() {
                    return [
                      _c("div", { staticClass: "row justify-content-end" }, [
                        _c("div", { staticClass: "col-auto" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary btn-lg",
                              on: {
                                click: function($event) {
                                  return _vm.close()
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-ban" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.resource("Button_Cancel")) +
                                  "\n                    "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-auto" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-lg",
                              class: { disabled: _vm.$v.$invalid },
                              attrs: { disabled: !_vm.canWrite },
                              on: {
                                click: function($event) {
                                  return _vm.save()
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-save" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.resource("Button_Save")) +
                                  "\n                    "
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3104421933
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              on: {
                click: function($event) {
                  return _vm.open()
                }
              }
            },
            [
              _c("i", { staticClass: "far fa-list-alt mr-1" }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.resource(
                      "JourneyBuilder_Menu_Button_OpenJourneyFilters"
                    )
                  )
              )
            ]
          ),
          _vm._v(" "),
          _c("notification-circle", {
            attrs: { "notification-count": _vm.activeFilters.length }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }